import(/* webpackMode: "eager" */ "/app/apps/frontend/app/not-found.tsx");
